import {useEffect, useState} from 'react'
import {HttpContraparte} from '../api/httpContraparte'
import {QueryStatus} from 'src/types'
import {OperacionContraparteLimitesAprobadosPais} from "../types/dto";
import {FormFiltros} from "../../../../limites/FiltrosBusqueda";


export const useLimitesContraparte = (filtros: FormFiltros) => {
    const [limites, setLimites] = useState<OperacionContraparteLimitesAprobadosPais[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpContraparte.getLimites(filtros)
            .then(value => {
                setLimites(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [filtros])

    return {limites, refetch, status}
}
